<template>
  <q-dialog
    ref="dialog"
    :maximized="$q.platform.is.mobile"
    full-width
    @hide="onDialogHide"
  >
    <q-card class="q-dialog-plugin">
      <q-card-section class="row">
        <q-space />
        <q-btn
          v-close-popup
          flat
          round
          dense
          icon="close"
        />
      </q-card-section>
      <target-details-content
        :program="program"
        :target-id="targetId"
        :editable="editable"
        @ok="onContentOk"
        @cancel="onCancelClick"
      />
    </q-card>
  </q-dialog>
</template>
<script>
import TargetDetailsContent from 'components/Programs/TargetDetailsContent';

export default {
  name: 'TargetDetails',

  components: { TargetDetailsContent },

  props: {
    // ...your custom props
    program: {
      type: Object,
      required: true,
    },

    targetId: {
      type: String,
      required: true,
    },

    editable: {
      type: Boolean,
      default: true,
    },

  },

  emits: ['hide', 'ok'],

  methods: {
    show() {
      this.$refs.dialog.show();
    }, // show()

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    onDialogHide() {
      this.$emit('hide');
    }, // onDialogHide()

    onContentOk() {
      this.$emit('ok');

      this.hide();
    }, // onContentOk()

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    }, // onCancelClick()
  },
};
</script>
